import React from 'react';
import PropTypes from 'prop-types';
import 'react-vis/dist/style.css';
import 'components/widgets/widgetstyles.css';
import { connect } from 'react-redux';
import mapDispatchToProps from 'reducers/actions/dispatchProps';
import mapStateToProps from 'reducers/actions/stateToProps';
import { withSnackbar } from 'notistack';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import {TransactionHandler} from 'chits-data/dist';
import { AccountHandler, SubscriberHandler } from 'chits-data/dist';
import { WebClientStore } from 'web-client-store';

import LoadingOverlay from 'components/common/loadingOverlay';
import Constants from 'components/utils/constants';
import PopupCellRenderer from './PopupCellRenderer';
import { Checkbox } from '@material-ui/core';
// import selectAccount from 'components/common/selectAccount';

class ChitPayDashboard extends React.Component {

  constructor(props) {
    super(props);
    this._handler = new TransactionHandler();
    this._handlerSub = new SubscriberHandler();
    this._accountHandler = new AccountHandler();
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  state = {
    subs: {},
    entries: [],
    columnDefs: [],
    selectedTerm: {},
    termHeaders: [],
    width: window.innerWidth,
    showDueColumn: this.props.showDueColumn,
    clearCache: this.props.appState.clearCache,
    openOverlay: false
  };

	/**
	 * Will be executed once on mount
	 * and every time window resized
   * TODO: Move it to app.js
	 */
	updateWindowDimensions() {
		if (this.setState) {
			console.debug('capturing new window dimentions [' + window.innerWidth + 'x' + window.innerHeight + ']')
			this.setState({
				width: window.innerWidth,
				height: window.innerHeight
			})
		}
	}

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  componentDidMount = () => {
		// register a 'resize' event to capture the window dimentions
		window.addEventListener('resize', this.updateWindowDimensions);
    // Proceed with refresh calls
    this.handleReloadDashboard();
  };

  handleReloadDashboard = () => {
		// Check if the chit is started; if not redirect to account info page
    let ac = this._handler.getActiveAccount();
    // asynchronously load account information to props
    this._accountHandler.getAccountCached(ac).then((account)=>{
      if (account) {
        // TODO: Have this validation in a central location; ChitEngine perhaps.
        let { nextTerm } = account.chit_info;
        let chitNew = nextTerm === undefined;
        // let chitInitiated = !chitNew && nextTerm === 1;
        let chitActive = !chitNew && nextTerm > 1;
        let chitMatured = !chitNew && nextTerm === -1;

        if (chitActive || chitMatured) {
          this.props.setCurrentAccount(account);
          this.handleProceedWithDashboard(ac);
        } else {
          window.location.href = '/info?refresh=tran_init';
        }
      } else {
        window.location.href = '/info?refresh=tran_init';
      }
    })
  }

  handleProceedWithDashboard = (ac) => {
    let clearCache = this.state.clearCache;
    this.setState({ openOverlay: true })
    this._accountHandler.getAccountSubscribersCached(ac).then(async (accountSubscribers) => {
      let subscriberNames = accountSubscribers.reduce((obj, sub) => {
        obj[sub.sid] = {
          name: sub.name,
          index: sub.index
        };
        return obj;
      }, {});
      let subs = await this._handler.getPaymentDashboardDataCached(ac, clearCache);
      // .then((subs) => {
        // let subs = response.data.statusTable;
        // {
        //   "statusTable": {
        //     "Subscriber 1": [
        //       {
        //         "id": "605454451869d421a8019eb3",
        //         "term": 1,
        //         "date": "2021-Mar-15",
        //         "status": "unpaid",
        //         "type": "chit_contribution",
        //         "sub": "Subscriber 1"
        //       },
        let columns = {};
        let _rows = [];
        let _subs = Object.keys(subs);

        /**
         * For every subscriber combine the term payments into simple obj
         * { sub: 'Name', '1': 'paid', '2': 'unpaid'...}
         */
        _subs.forEach(_sub => {
          let _payments = subs[_sub];
          let _row = {
            sid: _sub,
            name: subscriberNames[_sub].name,
            index: subscriberNames[_sub].index
          };
          let _subDues = 0;
          let _bidDue = 0;
          _payments.forEach(_payment => {
            // if (_payment.subId) _row['id'] = _payment.subId;
            _row[_payment.term] = (_payment.status === 'unpaid') ? 'due' : 'paid';
            if (_payment.status === 'unpaid') {
              if (_payment.bid) {
                _bidDue = _payment.bid - _payment.amnt;
              } else {
                _subDues += _payment.amnt;
              }
            }

            // Also capture every term into an object to get distinct columns
            columns[_payment.term] = true;
          })

          _row['dues'] = _bidDue ? _subDues - _bidDue : _subDues;

          _rows.push(_row);
        })
        this.setState({ subs: subs, entries: _rows.sort((a,b)=>{
          if (a.index < b.index) return -1;
          if (a.index > b.index) return 1;
          else return 0;
        }), termHeaders: Object.keys(columns) })
        this.handleRefreshHeadersDefinitions()
      // })
    }).catch((err)=>{
      this.props.enqueueSnackbar(err, {
        variant : 'warning'
      });
    })
    //Clear transaction cache
    .then(()=>{
        WebClientStore.Cache.unsetAsync(
            Constants.INDEXED_KEYS.ACCOUNT_TRANSACTIONS + "_" + ac)
    })
    .finally(()=>{
      this.setState({ clearCache: false, openOverlay: false })
    })
    
  }

  getSubTerm = (sub, term) => {
    return this.state.subs[sub].filter(_t => _t.term === term)[0];
  }

  getAccountCurr = () => this.props.wallet.current && this.props.wallet.current.curr || "INR";

  getCalculatedHeaderGap = (noOfColumns) => {
    let { width } = this.state;

    // TODO: instead of marginal chase; use dynamic change
    // based on auto-resize of aggrid
    let subWidth = noOfColumns > 6 ? noOfColumns > 12 ? 120 : 100 : 80;
    let dueWidth = noOfColumns > 6 ? noOfColumns > 12 ? 74 : 62 : 50;
    let calculatedWidth = width - subWidth - dueWidth;

    let factor = (54 + 7.2) * noOfColumns;
    calculatedWidth -= factor;

    if (calculatedWidth < 0) {
      // window is too small; factor is too high;
      calculatedWidth = 1;
    } else if (calculatedWidth < 120) {
      // do nothing; this is minum
    } else {
      let reverseFactor = 10.2 * (20 - noOfColumns);
      calculatedWidth -= reverseFactor;

      let safeMargin = 0;
      calculatedWidth += safeMargin;
    }

    // safe check
    if (width - calculatedWidth - subWidth - dueWidth - factor > 0) {
      // set minium safe width
      calculatedWidth += width - calculatedWidth - subWidth - dueWidth - factor;
    }
    return calculatedWidth;
  }

  onStatusUpdate = (colId, sid, status, isPartial, amnt) => {
    console.log("onStatusUpdate")
    let subscriberTerms = this.state.subs[sid];
    let d = moment().format("YYYY-MM-DD");
    let due = 0;
    let _status = (status === 'paid' || isPartial ? 'unpaid' : 'paid');
    let terms = subscriberTerms.filter((_t) => {
      return _t.term === parseInt(colId);
    });
    let ids = terms.reduce((arr, _t) => {
      if (_t.bidId) {
        due -= _t.bid;
        arr.push(_t.bidId);
      }
      due += _t.amnt
      arr.push(_t.id);
      return arr;
    }, []);
    if (amnt) due -= amnt;
    let note = status === 'paid' ? '' :
      (isPartial ? `Paid ${amnt} on ${d}. Due ${due}` :
        `Paid in full on ${d}`)

    this._handler
      .updateChitStatus({
        account: this._handler.getActiveAccount(),
        status: _status,
        ids,
        note,
      })
      .then(() => {
        // request to fetch a fresh copy
        Constants.requestTranRefresh();
        // request to clear cache
        this.setState({ clearCache: true })
      })
      .catch((err) => {
        this.props.enqueueSnackbar(
          "Unable to update status at this time. Please try again.",
          { variant: "warning" }
        );
      })
      .finally(() => this.handleReloadDashboard());
  }

  handleRefreshHeadersDefinitions = (_showDueColumn=true) => {
    let { wallet }= this.props;
    let isAuthorized = false;
    let { current } = wallet;
    if (current._id !== 'default') {
      let roles = Constants.extractRolesFromAccount(current);
      isAuthorized = roles.admin || roles.owner || roles.editor;
    }
    let { termHeaders } = this.state;
    let def = [];

    /**
     * Header: Subscriber
     */
    def.push({
      headerName: 'Subscriber',
      width: 158,
      field: 'name',
      resizable: true,
      pinned: 'left',
      cellRenderer: (params) => {
        return `${params.data.index}) ${params.value}`;
      },
      cellStyle: (params) => {
        return {
          color: 'blue',
          'font-size': 'small',
          'padding-left': '2px',
          'padding-right': '2px'
        };
      },
    });

    /**
     * Header(s): Each term; recent term on the right
     * Dynamically define one for each term
     */
    termHeaders.sort((a, b) => {
      if (parseInt(a) > parseInt(b)) return -1;
      if (parseInt(b) > parseInt(a)) return 1;
      else return 0;
    }).forEach((term) => {
      def.push({
        headerName: `${term}`,
        width: 52,
        field: term,
        cellRendererFramework: PopupCellRenderer,
        cellRendererParams: {
          isAuthorized,
          onStatusUpdate: this.onStatusUpdate,
          getSubTerm: this.getSubTerm,
          getAccountCurr: this.getAccountCurr,
          snackbar: this.props.enqueueSnackbar
        },
        // pinned: 'left',
        cellStyle: (params) => {
          return {
            'font-size': 'medium',
            'padding-left': '2px',
            'padding-right': '2px',
          }
        }
      })
    })

    if (_showDueColumn) {
      /**
       * Header: Total Due
       * Pin to the right so that always visible
       */
      def.push({
        headerName: 'Total Due',
        width: 74,
        field: 'dues',
        pinned: 'right',
        resizable: true,
        valueFormatter: (params) => {
          return Constants.toCurrencyES6(params.data.dues, this.getAccountCurr()).split('.')[0];
        },
        cellStyle: (params) => {
          let style = {
            'font-size': 'small',
            'text-align': 'right',
            'padding-left': '2px',
            'padding-right': '0px'
          }
          if (params.value <= 0) {
            style.color = 'blue';
          } else {
            style.color = 'red';
          }
          return style;
        },
      })
    }

    /**
     * Header: ... 
     * This is a logic column to fill the gap between right most term and the Total dues
     */

    let calculatedWidth = this.getCalculatedHeaderGap(termHeaders.length);
    def.push({
      headerName: '...',
      width: calculatedWidth
    })

    this.setState({ columnDefs: def, showDueColumn: _showDueColumn })
  }

  handleOnGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };

  overlayNoRowsTemplate = () => {
    let isStarted = this.state.subs.length > 0;
    return `<span>${isStarted ? 'No rows to show' : 'Chit is not yet started.'}</span>`
  }

  render() {
    return (

      <div className="content-fluid">
      <div className="row">
       <div className="col-md-12" >
         <div className="card">
           <div className="card-header"
            style={{textAlign: 'center'}}
           >
            <h4 className="card-title">Payment Dashboard</h4>
            <p className="card-category"
                                style={{ color: '#9C27B0', fontWeight: '500' }}
                            >{this.props.wallet.current.name}</p>
            {/* <p className="card-category">{wallet.current.name}</p> */}
            <label htmlFor='showDueColumn'
              style={{ float: "right", marginRight: '14px' }}
             >
            <Checkbox 
              id="showDueColumn"
              checked={this.state.showDueColumn}
              onChange={()=>{
                // this.setState({ showDueColumn: !this.state.showDueColumn })
                this.handleRefreshHeadersDefinitions(!this.state.showDueColumn)
              }}
              ></Checkbox>Show Total Dues</label>
            </div>
            <div className="card-body">

      {/* <Grid container style={{ "height": "70%", minWidth: "60%", maxWidth: "92%", marginLeft: "2px", marginRight: '2px', marginTop: "0px" }} > */}
         {/* <Grid item md={12} sm={12} xs={12}> */}
          <div className='ag-theme-balham' 
            // style={{ minWidth: "60%", maxWidth: "94%", marginLeft: "2.4%", marginTop: "0px" }}
            >
            {this.state.columnDefs.length > 1 &&
              <AgGridReact
                gridOptions={{
                  defaultColDef: {
                    headerClass: "ag-right-aligned-header",
                  },
                  rowHeight: 36,
                  suppressMovableColumns: true,
                  getRowStyle: params => {
                    if (params.node.rowIndex % 2 === 0) {
                      return { background: Constants.COLORs.BOODIDA };
                    }
                  },
                }}
                //TODO: Handle all three cases; 1. not ready, 2. not started, 3. no data.
                overlayNoRowsTemplate={this.overlayNoRowsTemplate()}
                columnDefs={this.state.columnDefs}
                rowData={this.state.entries}
                onGridReady={this.handleOnGridReady}
                enableCellTextSelection="true"
                rowSelection="none"
                animateRows
                domLayout="autoHeight"
              />}
          </div>
         {/* </Grid> */}
       {/* </Grid> */}

       </div>
       </div>
       </div>
       </div>

        {this.state.openOverlay && <LoadingOverlay />}
       </div>
    );
  }
}

ChitPayDashboard.defaultProps = {
  selectAccount: {},
  showDueColumn: false
}

ChitPayDashboard.propTypes = {
  title: PropTypes.string,
  // selectedAccount: PropTypes.object,
  showDueColumn: PropTypes.bool
};

export default connect(
  mapStateToProps, 
  mapDispatchToProps
)(
  withSnackbar(
    ChitPayDashboard
  )
)